var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle110(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "445.6269964375968 54.47622695941163 21.593003562403226 22.310011016347616",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M463.22,66.24c-.02.33-.02.48-.04.62-.61,4.4-2.67,7.66-8.45,4.92-2.33-1.1-4.13-2.72-4.85-5.31-.74-2.67.17-5.36,2.38-6.98,1.42-1.03,3.13-1.45,4.48-.42,1.28.98,2.73,1.59,4.02,2.48,1.68,1.15,2.42,2.85,2.44,4.69ZM458.4,61.9c-.7.47-1.52.83-2.06,1.43-.44.48-.81,1.29-.74,1.91.12,1.06.9,1.84,1.95,2.13.32.09.91-.18,1.12-.46,1.18-1.62.97-3.26-.26-5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle110);
export default __webpack_public_path__ + "static/media/twinkle-1-10.aec90c504bc96fb254953e667743d8ad.svg";
export { ForwardRef as ReactComponent };